import moment from 'moment';
import { useEffect } from 'react';
import { RouterProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import Spinner from '../../components/common/Spinner';
import { setUserRegisterToLS } from '../../helpers/localstorage-helper';
import { EMAIL_ADDRESS, PROFILE_DETAILS } from '../../routes/routes';
import { storeApprovalDate } from '../../slices/auth-slice';
import { P3 } from '../../styles/FontStyles';
import { AuthLayoutTitle, TermsWrapper } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { FlexJustifyCenter } from '../../styles/stylesStyled';
import { CreationTypes } from '../../types/loginTypes';
import { termsAndConditionsSocialSign } from './TermsConditions.actions';
import { getContentBlock } from '../../slices/content-block-slice';

const TermsConditions = ({ history }: RouterProps) => {
  const dispatch = useAppDispatch();

  const { contentBlock, loading } = useAppSelector(
    (state) => state.contentBlock
  );

  const { user, referrerId } = useAppSelector((state) => state.auth.register);

  useEffect(() => {
    dispatch(getContentBlock({ contentBlockId: 115, languageId: 1 }));
  }, [dispatch]);

  const dateNow = moment().format();

  const handleSubmit = async () => {
    if (user?.creationType === CreationTypes.Google) {
      dispatch(termsAndConditionsSocialSign(history));
    } else {
      history.push(PROFILE_DETAILS);
      dispatch(storeApprovalDate(dateNow));

      setUserRegisterToLS({
        referrerId,
        approvalDate: dateNow
      });
    }
  };

  return (
    <>
      {loading && <Spinner fullScreen={true} transparent />}

      <AuthLayoutTitle>MAVIE TERMS & CONDITIONS</AuthLayoutTitle>

      <P3 center color={colors?.neutral500} mb='40'>
        In order to register your account, we will need you to read <br /> and
        agree with our terms & conditions. Scroll down.
      </P3>

      <TermsWrapper>
        <div
          dangerouslySetInnerHTML={{
            __html: contentBlock && contentBlock.content
          }}
        />
      </TermsWrapper>

      <FlexJustifyCenter>
        <Button w='200px' onClick={handleSubmit}>
          Accept
        </Button>
      </FlexJustifyCenter>
    </>
  );
};

export default TermsConditions;
